// =============================================================================
// FILE: packages/renderer/src/hooks/useDashboard.ts
// PURPOSE: TanStack Query hooks for live dashboard counts + activity.
// =============================================================================

import { useQuery } from '@tanstack/react-query';
import { call } from '../lib/api.js';
import { IPC } from '@bim/shared/constants/ipc.constants.js';

export interface DashboardStats {
  buildings:       number;
  floors:          number;
  rooms:           number;
  telecomSpaces:   number;
  racks:           number;
  assets:          number;
  switches:        number;
  patchPanels:     number;
  ports:           number;
  outlets:         number;
  connections:     number;
  fiberCables:     number;
  copperCables:    number;
  projects:        number;
  documents:       number;
  openClashes:     number;
  generatedAt:     string;
}

export interface DashboardActivityEntry {
  timestamp: string;
  tableName: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE';
  recordId:  string;
  userEmail: string | null;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => call<undefined, DashboardStats>(IPC.DASHBOARD_STATS),
    refetchInterval: 30_000,
  });
}

export function useDashboardActivity(limit = 20) {
  return useQuery({
    queryKey: ['dashboard', 'activity', limit],
    queryFn: () => call<{ limit: number }, DashboardActivityEntry[]>(IPC.DASHBOARD_RECENT_ACTIVITY, { limit }),
    refetchInterval: 15_000,
  });
}
